import { render } from "./NewsEvents.vue?vue&type=template&id=c2740a3e"
import script from "./NewsEvents.vue?vue&type=script&lang=js"
export * from "./NewsEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__